import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Signup from "./components/Signup";
import HomePage from "./components/HomePage";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GOOGLE_CLIENT_ID = "476107595311-ftdgfb45bao7u93gkflstidnj6pjdjgm.apps.googleusercontent.com";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <Routes>
          {/* Default Route */}
          <Route
            path="/"
            element={
              isLoggedIn ? <Navigate to="/home" replace /> : <Login onLogin={handleLogin} />
            }
          />
          <Route
            path="/signup"
            element={isLoggedIn ? <Navigate to="/home" replace /> : <Signup />}
          />
          <Route
            path="/home"
            element={
              isLoggedIn ? <HomePage onLogout={handleLogout} /> : <Navigate to="/" replace />
            }
          />
          {/* Catch-All Route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
